module.exports = __webpack_public_path__ + "img/logo-inter-mutuelle-assistance.034cab55.webp";